import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription, switchMap } from 'rxjs';
import { DetailService } from '../../../pim-graphql/views/detail-view/detail-view/detail.service';
import { HeaderData } from '../../../pim-graphql/views/shared-view.model';
import { RefreshService } from 'src/app/services/refresh.service';

@Component({
  selector: 'app-detail-set',
  templateUrl: './detail-set.component.html',
  styleUrls: ['./detail-set.component.scss'],
  standalone: false,
})
export class DetailSetComponent implements OnInit, OnDestroy {
  private detailService = inject(DetailService);
  private route = inject(ActivatedRoute);
  private refreshService = inject(RefreshService);

  setId!: string;
  headerData?: HeaderData;
  loading = true;
  private paramSubscription?: Subscription;

  ngOnInit(): void {
    this.paramSubscription = combineLatest([
      this.route.params,
      this.refreshService.refreshData$,
    ])
      .pipe(
        switchMap((values) => {
          this.setId = values[0]['setId'];
          this.headerData = undefined;
          this.loading = true;

          return this.detailService.getDetailHeader(this.setId);
        }),
      )
      .subscribe((detailData) => {
        this.headerData = detailData;
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.paramSubscription?.unsubscribe();
  }
}
